"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freezeMapAttribute = void 0;
const index_js_1 = require("../../errors/index.js");
const attributeOptions_js_1 = require("../constants/attributeOptions.js");
const validate_js_1 = require("../shared/validate.js");
const interface_js_1 = require("./interface.js");
/**
 * Freezes a warm `map` attribute
 *
 * @param attributes Attribute elements
 * @param state Attribute options
 * @param path Path of the instance in the related schema (string)
 * @return void
 */
const freezeMapAttribute = (state, attributes, path) => {
    (0, validate_js_1.validateAttributeProperties)(state, path);
    const attributesSavedAs = new Set();
    const keyAttributeNames = new Set();
    const requiredAttributeNames = {
        always: new Set(),
        atLeastOnce: new Set(),
        never: new Set()
    };
    const frozenAttributes = {};
    for (const [attributeName, attribute] of Object.entries(attributes)) {
        const { savedAs: attributeSavedAs = attributeName, key: attributeKey, required: attributeRequired } = attribute[attributeOptions_js_1.$state];
        if (attributesSavedAs.has(attributeSavedAs)) {
            throw new index_js_1.DynamoDBToolboxError('schema.mapAttribute.duplicateSavedAs', {
                message: `Invalid map attributes${path !== undefined ? ` at path '${path}'` : ''}: More than two attributes are saved as '${attributeSavedAs}'.`,
                path,
                payload: { savedAs: attributeSavedAs }
            });
        }
        attributesSavedAs.add(attributeSavedAs);
        if (attributeKey) {
            keyAttributeNames.add(attributeName);
        }
        requiredAttributeNames[attributeRequired].add(attributeName);
        frozenAttributes[attributeName] = attribute.freeze([path, attributeName].join('.'));
    }
    return new interface_js_1.MapAttribute_({
        path,
        attributes: frozenAttributes,
        ...state
    });
};
exports.freezeMapAttribute = freezeMapAttribute;
